import React, { Component } from "react";
import generateContentDataObject from "../../helpers/editor/generateContentDataObject";
import { callToActionOptions } from "../../data/callToActionOptions";
import { linkOrButtonOptions } from "../../data/linkOrButtonOptions";
import { buttonStyles } from "../../data/buttonStyles";
import { GraphicsOptions } from "../../components/editor/component_graphics/data/componentGraphicsData";
import MockupWithContent from "../../components/MockupWithContent";
import _ from "lodash";
import { displayTitleMarkupText } from "../../helpers/content_displayers/displayTitleMarkupText";
import { displaySubtitleMarkupText } from "../../helpers/content_displayers/displaySubtitleMarkupText";
import WebsiteCTA from "../component_molecules/WebsiteCTA";
import { DEFAULT_IMAGES_CDN } from "../../data/urls";

interface Props {
  componentItem: any;
  checkIsEmptyContent: any;
  saveContentInStore: any;
  connectDefaultFormIntegration: any; //we need this to connect an integration to forms in CTAs
  isDarkBg: boolean;
}

class Header62 extends Component<Props> {
  generator = new generateContentDataObject();

  componentWillMount(): void {
    const { isDefaultEmpty, defaultCtaOption } = this.props.componentItem;
    //check if the component has not content (when just added). if so, generate some default dummy content.
    // also change inputs tooltips, placeholders text if needed. E.g. when a component needs an image of a particular size.
    if (this.props.checkIsEmptyContent()) {
      //generate defaultContent{}. Use special methods of the generateContentDataObject class;

      this.props.saveContentInStore(
        this.generator.setUpGraphics({
          activeOption: GraphicsOptions.image,
          userCanAddItems: false,
          maxItems: 2,

          label: {
            [GraphicsOptions.image]: "Upload the images:",
            [GraphicsOptions.video]: "Enter URL to Youtube video:",
            default: "Upload the images:",
          },

          fieldTitle: {
            [GraphicsOptions.image]: "Edit the app screenshots",
            [GraphicsOptions.video]: "Video",
            default: "Edit the app screenshots",
          },

          fieldInfo: {
            [GraphicsOptions.image]: "",
            [GraphicsOptions.video]: "",
            default: "",
          },
          items: [
            this.generator.createGraphicsContentObject({
              imageUrl: DEFAULT_IMAGES_CDN.UI_MOBILE_DASHBOARD,
              videoUrl:
                "https://up-blog-prod.s3.amazonaws.com/waterfall_compressed.mp4",
              width: 412,
              height: 892,
            }),
            this.generator.createGraphicsContentObject({
              imageUrl: DEFAULT_IMAGES_CDN.UI_MOBILE_PROFILE,
              videoUrl:
                "https://up-blog-prod.s3.amazonaws.com/neon_compressed.mp4",
              width: 412,
              height: 892,
            }),
          ],
        })
      );
      this.props.saveContentInStore(
        this.generator.setUpTitle({
          titleText: "Because Your App Deserves the Best",
          isDefaultEmpty
        })
      );
      this.props.saveContentInStore(this.generator.setUpSubtitleText({isDefaultEmpty}));
      this.props.saveContentInStore(
        this.generator.setUpMockups({
          items: [
            this.generator.createMockupsContentObject({
              type: "mobile",
              deviceId: "iphone_11_pro_max",
              optionId: "space_grey",
              fileName: "apple_iphone_11_pro_max_space_grey.png",
              humanTitle: "iPhone 11 Pro Max",
            }),
            this.generator.createMockupsContentObject({
              type: "mobile",
              deviceId: "pixel_4_xl",
              optionId: "black",
              fileName: "google_pixel_4_xl_just_black.png",
              humanTitle: "Google Pixel 4 XL",
            }),
          ],
        })
      );
      this.props.saveContentInStore(
        this.generator.setUpCta({
          activeOption: defaultCtaOption || callToActionOptions.buttons,
          isDefaultEmpty,

          buttons: [
            this.generator.createButtonContentObject({
              buttonType: linkOrButtonOptions.link,
              buttonTitle: "Get it",
              buttonHref: "/download-ios",
              buttonStyleType: buttonStyles.mobileAppStore.typeTitle,
              buttonMobileAppStoreType: buttonStyles.mobileAppStore.ios,
              buttonColor: buttonStyles.regular.accentBg,
              buttonIsTargetBlank: false,
              pillPrefix: "Whoa!",
            }),

            this.generator.createButtonContentObject({
              buttonType: linkOrButtonOptions.link,
              buttonTitle: "About us",
              buttonHref: "/download-android",
              buttonStyleType: buttonStyles.mobileAppStore.typeTitle,
              buttonMobileAppStoreType: buttonStyles.mobileAppStore.android,
              buttonColor: buttonStyles.regular.blackOutline,
              buttonIsTargetBlank: false,
              pillPrefix: "New",
            }),

            // ghost object
            this.generator.createButtonContentObject({
              buttonType: linkOrButtonOptions.link,
              buttonTitle: "",
              buttonHref: "",
              buttonStyleType: buttonStyles.ghost.typeTitle,
              buttonColor: buttonStyles.ghost.accentOutline,
              buttonIsTargetBlank: false,
              pillPrefix: "View",
            }),
          ],
        })
      );
    }
  }

  render() {
    this.props.connectDefaultFormIntegration(this.props.componentItem);

    // these variables contain content. we need to wait a little before content schemes with default data will be populated (it happens on the componentWillMount even, each time we launch generator).
    // see the content schema in the helpers/editor/generateContentDataObject.ts
    let title = displayTitleMarkupText(
      this.props.componentItem.componentData.title.content.markup
    );
    let subtitleText = displaySubtitleMarkupText(
      this.props.componentItem.componentData.subtitleText.content.markup
    );

    let frontGraphicsObject = this.props.componentItem.componentData.graphics
      .content.items[0];
    let backGraphicsObject = this.props.componentItem.componentData.graphics
      .content.items[1];

    let frontMockup = displayTitleMarkupText(
      this.props.componentItem.componentData.mockups.content.items[0]
    );
    let backMockup = displayTitleMarkupText(
      this.props.componentItem.componentData.mockups.content.items[1]
    );

    const currentActiveOption: GraphicsOptions = _.get(
      this.props.componentItem,
      ["componentData", "graphics", "activeOption"]
    );

    return (
      <header
        className={`header-62 graphics-${currentActiveOption} default-graphics-${GraphicsOptions.image}`}
      >
        <div className="container container--large header-62__container">
          <div className="header-62__info">
            <div className="header-62__info_content">
              {title.length > 0 && (
                <h1
                  className={
                    "title-text heading heading--accent header-62__heading " +
                    (this.props.isDarkBg ? "text-white" : "")
                  }
                  dangerouslySetInnerHTML={{ __html: title }}
                />
              )}

              {subtitleText.length > 0 && (
                <p
                  className={
                    "subtitle-text header-62__text content_box " +
                    (this.props.isDarkBg ? "text-white" : "")
                  }
                  dangerouslySetInnerHTML={{ __html: subtitleText }}
                />
              )}

              <div className="header-62__buttons_box">
                <ul className="header-62__buttons">
                  <WebsiteCTA
                    componentItem={this.props.componentItem}
                    isDarkBg={this.props.isDarkBg}
                  />
                </ul>
              </div>
            </div>
          </div>
          <div className="header-62__visual">
            <div className="header-62__visual__wrapper">
              <div className="header-62__mockup header-62__mockup--static">
                <MockupWithContent
                  mockupObject={backMockup}
                  graphicsObject={backGraphicsObject}
                  isDarkBg={this.props.isDarkBg}
                  currentActiveOption={currentActiveOption}
                  HTMLClassNames="graphics-HTML__editor-code_mobile-mockup"
                />
              </div>
              <div className="header-62__mockup header-62__mockup--shift">
                <MockupWithContent
                  mockupObject={frontMockup}
                  graphicsObject={frontGraphicsObject}
                  isDarkBg={this.props.isDarkBg}
                  currentActiveOption={currentActiveOption}
                  HTMLClassNames="graphics-HTML__editor-code_mobile-mockup"
                />
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default Header62;
